module.exports = __webpack_public_path__ + "static/media/lease.8ae2eac4.svg";